import React, { forwardRef, memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Button.scss";
import textInputStyles from "./TextInput.scss";
import { FormattedMessage } from "react-intl";
import { Button as FluentButton } from "@fluentui/react-components";

export const presets = [
  "transparent",
  "basic",
  "primary",
  "accept",
  "cancel",
  "outline",
  "accent1",
  "accent2",
  "accent3",
  "accent4",
  "accent5",
  "accent6",
  "accent7",
  "accent8",
  "landing",
  "signin",
  "text"
];

/* eslint-disable-next-line react/display-name */
export const Button = memo(
  forwardRef(({ as, sm, lg, xl, thin, thick, preset, className, children, ...rest }, ref) => {
    const ButtonComponent = as;
    const buttonProps = ButtonComponent === "button" ? { type: "button" } : {};

    return (
      <ButtonComponent
        className={classNames(
          styles.button,
          textInputStyles.button,
          styles[preset],
          {
            [styles.sm]: sm,
            [styles.lg]: lg,
            [styles.xl]: xl,
            [styles.thin]: thin,
            [styles.thick]: thick
          },
          className
        )}
        {...buttonProps}
        {...rest}
        ref={ref}
      >
        {children}
      </ButtonComponent>
    );
  })
);

Button.propTypes = {
  as: PropTypes.elementType,
  preset: PropTypes.oneOf(presets),
  className: PropTypes.string,
  children: PropTypes.node,
  sm: PropTypes.bool,
  lg: PropTypes.bool,
  xl: PropTypes.bool,
  thin: PropTypes.bool,
  thick: PropTypes.bool
};

Button.defaultProps = {
  as: "button",
  preset: "basic"
};

export function NextButton(props) {
  return (
    <FluentButton appearance="primary" {...props}>
      <FormattedMessage id="button.next" defaultMessage="Next" />
    </FluentButton>
  );
}

export function TryAgainButton(props) {
  return (
    <FluentButton {...props} appearance="primary">
      <FormattedMessage id="button.try-again" defaultMessage="Try again" />
    </FluentButton>
  );
}

export function CancelButton(props) {
  return (
    <FluentButton appearance="primary" {...props}>
      <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
    </FluentButton>
  );
}

export function ContinueButton(props) {
  return (
    <FluentButton appearance="primary" {...props}>
      <FormattedMessage id="button.continue" defaultMessage="Continue" />
    </FluentButton>
  );
}

export function AcceptButton(props) {
  return (
    <FluentButton appearance="primary" {...props}>
      <FormattedMessage id="button.accept" defaultMessage="Accept" />
    </FluentButton>
  );
}

export function ApplyButton(props) {
  return (
    <FluentButton appearance="primary" {...props}>
      <FormattedMessage id="button.apply" defaultMessage="Apply" />
    </FluentButton>
  );
}

export function SaveButton(props) {
  return (
    <FluentButton appearance="primary" {...props}>
      <FormattedMessage id="button.save" defaultMessage="Save" />
    </FluentButton>
  );
}

export function OutlineButton(props) {
  return (
    <FluentButton appearance="outline" {...props}>
      <FormattedMessage id="button.outline" defaultMessage="Outline" />
    </FluentButton>
  );
}
